import React from 'react';
// Zustand
import { useStore } from '../../zustand';
// Helpers
import { sendAnalyticsData } from "../../utility/handleAnalytics";
import { setARCartURL } from "../../utility/helpers";

// Icons
import { ReactComponent as Cart } from "../../assets/icons/cart.svg";
// Styles
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    buttonContainer: {
        display: 'flex',
        justifyContent: props => props.viewer_button.button_position,
        lineHeight: 1,
        marginBottom: '1rem',
        [theme.breakpoints.down('sm')]: {
            marginRight: '1rem',
            marginBottom: 0,
        },
        '& button': {
            display: 'flex',
            alignItems: 'center',
            border: 'none',
            boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
            cursor: 'pointer',
            outline: 'none',
            transition: 'all .3s ease',
            maxWidth: '100%',
            opacity: 1,
            lineHeight: 1,
            borderRadius: 4,
            '&:hover': {
                opacity: .65
            },
            textTransform: 'uppercase',
            background: props => props.viewer_button.button_color,
            color: props => props.viewer_button.button_text_color,
            fontFamily: props => props.default_text_font,
            
        },
        [theme.breakpoints.up('md')]: {
            width: '100%',
        },
    },
    billboard_style: {
        fontWeight: 700,
        fontSize: '.8rem',
        padding: '8px 0 5px',
        '& svg': {
            maxWidth: 22,
            marginLeft: 8
        }
    },
    normal_style: {
        fontWeight: 600,
        fontSize: '1em',
        padding: '7px 15px 6px',
        '& svg': {
            maxWidth: 25,
            marginLeft: 10
        }
    },
}));

export default function CartBtn(props) {
    // const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const classes = useStyles(dynamic_text_settings);
    const { vList } = useStore.getState().variants_payload;
    const variant_id = useStore.getState().variant_id;
    const { origin, variant_type } = useStore.getState().settings;
    var show_cart_btn = true;

    if (variant_type === 'bco' &! vList[variant_id].sku) {
        show_cart_btn = false;
    }

    const cartExit = async () => {
        let levar_cart_redirect = setARCartURL(variant_id, vList, variant_type)

        if(levar_cart_redirect) {
            await sendAnalyticsData({ event_type: 'viewer_page_exit' });
            window.location.assign(levar_cart_redirect);
        }
    };

    if(origin === 'static') return null;

    if(!show_cart_btn) return null;
    
    return (
        <div className={classes.buttonContainer}>
            <button className={clsx({
                        [classes.billboard_style] : props.type === 'billboard',
                        [classes.normal_style] : props.type === 'normal'
                    })}
                onClick={() => cartExit()}>
                    <span>Add to Cart</span>
                    <Cart className={classes.cart_icon} />
            </button>
        </div>
    );
}